import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cbd11bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

import { ref, reactive, watch, computed } from 'vue'
import { t } from '@/plugins/i18n'
import useForm from '@/util/useForm'
import useRules, { useMust } from '@/util/useRules'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { getTotalCountryList, getAreaList, getAddressCodeName } from '@/util/useCountry'
import SortSelect from '@/components/common/SortSelect.vue'
import { getCountryListApi } from '@/apis/user'
import { isKO, useSite2Code } from '@/store'
import { useStore } from 'vuex'
import { openKakooAddr } from '@/plugins/addr'


export default /*#__PURE__*/_defineComponent({
  props: ['modelValue', 'data'],
  emits: ['update:modelValue', 'update:data', 'change'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()



const model: any = reactive({
  sendName: '',
  sendTel: '',
  countryCode: '',
  area: '',
  city: '',
  address: '',
  postalCode: ''
})

watch(
  () => props.modelValue,
  async (v) => {
    if (!v) return
    const addressInfo = await getAddressCodeName({
      ...props.data,
      countryCode: !props.data.countryCode || props.data.countryCode.indexOf('+') > -1 ? store.getters?.user?.nationCode : props.data.countryCode
    })
    console.log('countryList.value', countryList.value, addressInfo)
    const isHaveCountry = countryList.value.find((item:any) => {
      return item.code === addressInfo.countryCode
    })
    // countryList.value = addressInfo.countryList
    if (isHaveCountry) {
      prov1inces.value = addressInfo.areaList
      cities.value = addressInfo.cityList
      model.sendName = addressInfo.sendName
      model.sendTel = addressInfo.sendTel
      model.countryCode = addressInfo.countryCode
      model.postalCode = addressInfo.postalCode
      model.sendTel = addressInfo.sendTel
      model.address = addressInfo.address
      model.country = addressInfo.countryItem?.intAreaId
      model.area = addressInfo.areaItem?.intAreaId
      model.city = addressInfo.cityItem?.intAreaId
      phoneCode.value = '+' + addressInfo?.countryItem.areaNum
    } else {
      prov1inces.value = []
      cities.value = []
      model.sendName = ''
      model.sendTel = ''
      model.countryCode = ''
      model.postalCode = ''
      model.sendTel = ''
      model.address = ''
      model.country = ''
      model.area = ''
      model.city = ''
      phoneCode.value = ''
    }
  }
)

const countryList:any = ref([])
const prov1inces: any = ref([])
const cities: any = ref([])
const phoneCode = ref('')

const rules = computed(() => {
  clearFomValidate()
  return {
    sendName: useRules({ message: t('必填'), key: 'deliver' }),
    sendTel: useRules({ message: t('必填'), key: 'phone' }),
    area: useMust(t('必填'), 'change'),
    // city: useMust(t('必填'), 'change'),
    address: useRules({ message: t('必填'), key: 'address' }),
    postalCode: useRules({ message: t('必填'), key: model.country === '2279' ? 'postal' : 'postalCode' })
  }
})

const cancel = () => {
  emit('update:modelValue', false)
}

const [formRef, commit] = useForm(() => {
  emit('update:data', model)
  emit('update:modelValue', false)
  emit('change')
})
getTotalCountryList().then((res:any) => {
  getCountryListApi({}).then((result:any) => {
    const codes = result.data.map((i:any) => i.countryCode)
    countryList.value = res.filter((i:any) => codes.indexOf(i.code) > -1)
  })
})
// 修改国家时重置省市
const changeCountry = (item:any) => {
  getAreaList(item).then((res:any) => {
    model.area = ''
    model.city = ''
    model.postalCode = ''
    model.address = ''
    phoneCode.value = '+' + item.areaNum
    prov1inces.value = res
    cities.value = []
    model.countryCode = item.code
    clearFomValidate()
  })
}
const changeArea = (item:any) => {
  console.log(item)
  model.city = ''
  getAreaList(item).then((res:any) => {
    cities.value = res
  })
}

const clearFomValidate = () => {
  setTimeout(() => {
    formRef.value && formRef.value.clearValidate()
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    "model-value": __props.modelValue,
    onClose: cancel,
    width: 650,
    title: _unref(t)('国际面单依赖主设定'),
    footer: true,
    onOk: _unref(commit),
    onCancel: cancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          class: "receive-form",
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            _isRef(formRef) && (formRef.value = _value)
          },
          model: _unref(model),
          rules: _unref(rules),
          inline: true,
          "label-width": 138
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "country",
              label: _unref(t)('国/地区')
            }, {
              default: _withCtx(() => [
                _createVNode(SortSelect, {
                  value: _unref(model).country,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).country) = $event)),
                  onChange: changeCountry,
                  list: countryList.value,
                  type: "country",
                  "dont-select": _unref(isKO)(),
                  rowKey: "intAreaId",
                  width: 400
                }, null, 8, ["value", "list", "dont-select"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "sendName",
              label: _unref(t)('姓名')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "receive-name",
                  modelValue: _unref(model).sendName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).sendName) = $event)),
                  maxlength: 20,
                  placeholder: _unref(t)('请输入姓名'),
                  style: {"width":"400px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              style: {"margin-right":"300px"},
              prop: "sendTel",
              label: _unref(t)('联系电话')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "receive-tel",
                  modelValue: _unref(model).sendTel,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).sendTel) = $event)),
                  maxlength: 20,
                  placeholder: _unref(t)('请输入手机号'),
                  style: {"width":"400px"}
                }, {
                  prepend: _withCtx(() => [
                    _createTextVNode(_toDisplayString(phoneCode.value || '-'), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_unref(isKO)())
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "postalCode",
                  label: _unref(t)('邮编')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "postal-code",
                      modelValue: _unref(model).postalCode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).postalCode) = $event)),
                      maxlength: 20,
                      placeholder: _unref(t)('请输入邮编'),
                      style: {"width":"300px","margin-right":"10px"},
                      disabled: "",
                      readonly: ""
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      style: {"width":"90px"},
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(openKakooAddr)(_unref(model),prov1inces.value,['area'])))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('搜索地址')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  style: {"margin-right":"400px"},
                  prop: "postalCode",
                  label: _unref(t)('邮编')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "receive-mailcode",
                      modelValue: _unref(model).postalCode,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(model).postalCode) = $event)),
                      maxlength: 20,
                      style: {"width":"400px"},
                      placeholder: _unref(t)('请输入邮编')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"])),
            _createVNode(_component_el_form_item, {
              style: {"margin-right":"400px"},
              prop: "area",
              label: _unref(model).country === '2279' ? _unref(t)('都道府县') : _unref(t)('都道府県/州/地域')
            }, {
              default: _withCtx(() => [
                _createVNode(SortSelect, {
                  value: _unref(model).area,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(model).area) = $event)),
                  onChange: changeArea,
                  list: prov1inces.value,
                  type: "area",
                  rowKey: "intAreaId",
                  width: 400,
                  country: _unref(model).country,
                  "dont-select": _unref(isKO)()
                }, null, 8, ["value", "list", "country", "dont-select"])
              ]),
              _: 1
            }, 8, ["label"]),
            (!_unref(isKO)())
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  style: {"margin-right":"400px"},
                  prop: "city",
                  label: _unref(t)('市')
                }, {
                  default: _withCtx(() => [
                    _createVNode(SortSelect, {
                      value: _unref(model).city,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(model).city) = $event)),
                      list: cities.value,
                      type: "city",
                      rowKey: "intAreaId",
                      width: 400,
                      country: _unref(model).country
                    }, null, 8, ["value", "list", "country"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              style: {"width":"80%"},
              prop: "address",
              label: _unref(t)('详细地址')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 2 },
                  class: "receive-address",
                  modelValue: _unref(model).address,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(model).address) = $event)),
                  maxlength: 100,
                  placeholder: _unref(t)('请输入详细地址'),
                  style: {"width":"400px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "onOk"]))
}
}

})